import type { RoleProtectedProps } from '@config/types';
import PropTypes from 'prop-types';

// project imports
import useAuth from '@hooks/useAuth';

export default function AuthGuardComponent({ children, allowedRoles }: RoleProtectedProps) {
  const { user, isAuthenticated } = useAuth();
  const role = user?.role;
  if (isAuthenticated && allowedRoles.includes(role)) return <>{children}</>;
}

AuthGuardComponent.propTypes = { children: PropTypes.any };
